import React from 'react';

import LogoRegular from '@sdk/login/components/LogoRegular';

import { Container, InnerContainer, SpaceBetween, GrowRow } from './Layout.styles';

export const Layout = ({ children }) => (
  <Container>
    <InnerContainer>
      <SpaceBetween>
        <LogoRegular />
      </SpaceBetween>
      <GrowRow>{children}</GrowRow>
    </InnerContainer>
  </Container>
);
